module.exports = "<div class=\"msg-row\" *ngIf=\"systemMessage.content\">\n    <div class=\"start-message\">\n        <i\n            [class]=\"systemMessage.getIconSize() + ' icon ' + systemMessage.getIconColor()\"\n        >{{ systemMessage.getIcon() }}</i>\n        <p [innerHtml]=\"systemMessage.content|safeHtml\"></p>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/chat/childs/system/system.component.html
// module id = 587
// module chunks = 0